import { createFeatureSelector, createSelector } from "@ngrx/store";

import { Canal, SettingsStateKeys } from '@libs/entity-lib';
import * as fromSettings from '@libs/settings-state';

export const getSettingsState =
  createFeatureSelector<fromSettings.State>(SettingsStateKeys.SETTINGS_SOCIAL_SPORT);


  export const getCanal = createSelector(
    getSettingsState,
    (state): Canal => state?.canal ?? Canal.UNDEFINED
  );